module.exports = __webpack_public_path__ + "media/images/redesign-images/fraternity/brag/brag-05-687ed30c9cc54bec8d34b632d3bb6099.jpg";